export default __webpack_public_path__ + "static/media/gifimage01.ab90ee2a.gif";